import React from 'react'
import styles from './AboutMe.module.scss'
import { motion } from "framer-motion"
import image from '../../image/AboutMe/img_2.jpg'

const AboutMe = ({isRus, isCareerOpen}) => {

    return (
        <motion.section 
        className={styles.main}
        id='gruppy' 
        initial='hidden'
        whileInView='visible'
        viewport={{amount: 0.05, once: true}}
        >
            <div className={styles.container}>
                <div className={styles.info}>
                    <h2 className={styles.title}>{ isRus  ? 'ОБО МНЕ' : 'about me'}</h2>
                    <h3 className={styles.subtitle}>{ isRus  ? 'Двадцатилетний опыт работы директором по развитию бизнеса “Carrier Corporation” (подразделение “Carrier Transicold” / транспортное холодильное оборудование) в России и СНГ' : '20 years of experience as Director of Business Development at Carrier Corporation (Carrier Transicold division / transport refrigeration equipment) in Russia and the CIS'}</h3>
                    <p className={styles.text}>{ isRus  ? 'Проходил обучение и стажировки в США по программам подготовки управленческих кадров ' : 'He studied and interned in the United States under the management training program at Harvard University.'}</p>
                    <p className={styles.text_min}>{ isRus  ? 'Диплом МБА при РЭА им. Г.В. Плеханова по специальности - финансовый менеджмент' : 'MBA at Plekhanov Russian Academy of Economics'}</p>
                    <p className={styles.text_min}>{ isRus  ? 'Диплом Всероссийской Академии Внешней Торговли' : 'All-Russian Academy of Foreign Trade of the Ministry of Economic Development of the Russian Federation'}</p>
                    <div className={styles.box_button}>
                        <button className={styles.button} type='button' onClick={isCareerOpen}>{ isRus  ? 'образование и карьера' : 'education and career'} <span className={styles.glare}></span></button>
                    </div>
                </div>
                <img className={styles.image} src={image} alt='человек'/>
            </div>   
    </motion.section>
    )
}

export default AboutMe